<app-playground title="{{ 'profile' | translate }}"> </app-playground>
<div class="container accordion-open">
    <br />
    <br />
    <div ngbAccordion [closeOthers]="true" type="light">
        @if (user) {
        <div ngbAccordionItem>
            <h6 ngbAccordionHeader>
                <button ngbAccordionButton>
                    {{ "Personal/BusinessData" | translate }}
                </button>
            </h6>
            <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                    <ng-template>
                        <app-user-input></app-user-input>
                    </ng-template>
                </div>
            </div>
        </div>
        }
        @if (user) {
        <div ngbAccordionItem>
            <h6 ngbAccordionHeader>
                <button ngbAccordionButton>
                    {{ "E-Mail" | translate }}
                </button>
            </h6>
            <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                    <ng-template>
                        <div class="row pt-3">
                            <div class="col">
                                <p>
                                    {{ "changeEmailInfoText" | translate }}
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 change-mail-input">
                                <label for="inputEmail" class="form-label">{{ "E-Mail" | translate }}</label>
                                <input id="inputEmail" class="form-control" [disabled]="!changeClicked"
                                    [(ngModel)]="changedEmail" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col d-flex" style="margin-top: 20px; align-items: center; gap: 5px;">
                                @if (!changeClicked) {
                                <ion-button fill="outline" color="primary" type="button" (click)="changeEmail()">
                                    {{ "change" | translate }}
                                </ion-button>
                                }
                                @if (changeClicked) {
                                <ion-button
                                    fill="outline"
                                    color="primary"
                                    type="button"
                                    [disabled]="isEmailUnchanged"
                                    (click)="sendChangeEmailRequest()">
                                    {{ "sendRequest" | translate }}
                                </ion-button>
                                <ion-button
                                    fill="outline"
                                    color="secondary"
                                    type="button"
                                    (click)="cancelEmailChange()">
                                    {{ "Cancel" | translate }}
                                </ion-button>
                                }
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        }

        <div ngbAccordionItem>
            <h6 ngbAccordionHeader>
                <button ngbAccordionButton>
                    {{ "Newsletter" | translate }}
                </button>
            </h6>
            <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                    <ng-template>
                        <div class="row pt-3">
                            <div class="col">
                                <strong>{{ "IWantNews" | translate }}</strong>
                            </div>
                        </div>
                        <div class="row pt-3 newsletter-container">
                            <app-newsletter class="col" lang="DE" [newsletterTimestamps]="
                                    user.newsletterTimestamps
                                ">
                            </app-newsletter>
                            <app-newsletter class="col" lang="EN" [newsletterTimestamps]="
                                    user.newsletterTimestamps
                                ">
                            </app-newsletter>
                            <app-newsletter class="col" lang="FR" [newsletterTimestamps]="
                                    user.newsletterTimestamps
                                ">
                            </app-newsletter>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <small
                                    [innerHTML]="'NewsletterLegalNotice' | translate : {layer: params.country?.code}"></small>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <div class="pb-5">
        <h6 class="pt-5" style="font-size: 18px">
            {{ "DeleteAccount" | translate }}
        </h6>
        <p style="margin-top: 20px; margin-bottom: 10px">
            {{ "InfoDeleteAccount" | translate }}
        </p>
        <a class="link" (click)="onDeleteUserClick()"><em class="fa fa-trash-alt"></em>
            {{ "DeleteAccount" | translate }}</a>
    </div>
</div>